<!-- Háttér overlay a panel bezárásához -->
@if (isPanelOpen) {
  <div class="panel-backdrop" (click)="closePanel()"></div>
}

<!-- Slide-out napi naptár panel -->
<div class="calendar-panel" [class.open]="isPanelOpen">
  <!-- Napi naptár nézet (toolbar a FullCalendar-ban) -->
  <div class="panel-body" #panelBody>
    @if (isLoading) {
      <div class="panel-loading">
        <mat-spinner diameter="28"></mat-spinner>
      </div>
    }
    @if (isCalendarReady) {
      <full-calendar #panelCalendar [options]="calendarOptions"></full-calendar>
    }
  </div>
</div>

<!-- Lebegő gomb -->
<div
  #dragElement
  class="floating-calendar-btn"
  [class.panel-open]="isPanelOpen"
  cdkDrag
  cdkDragLockAxis="y"
  [cdkDragFreeDragPosition]="dragPosition"
  (cdkDragStarted)="onDragStarted()"
  (cdkDragEnded)="onDragEnded($event)"
  (click)="onClick()">
  <mat-icon class="arrow-icon">{{ isPanelOpen ? 'chevron_right' : 'chevron_left' }}</mat-icon>
  <mat-icon class="calendar-icon">calendar_month</mat-icon>
</div>
